import { buildValidations, validator } from 'ember-cp-validations';
export default buildValidations({
  selectors: validator('pointer-has-selector')
});